import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { SectionAReportLayerList } from '../components/Report/SectionAReportLayerList'

export const SectionAReportPageList = () => {
  return (
    <MasterLayout>
        <SectionAReportLayerList/>
    </MasterLayout>
  )
}
